import React, { useCallback, useMemo } from 'react';
import { Segmented } from 'antd';
import { useSelector } from 'react-redux';
import { AvailableModals, closeModal } from '../modalSlice';
import { ReduxState, useAppDispatch } from '../../../store';
import { Row, Title } from '@ydistri/ds';
import { SegmentedValue } from 'antd/es/segmented';
import {
  displayTypeOptions,
  ExceptionsModalDisplayType,
  StyledModal,
} from './categoryExceptionsModalLib';
import { styled } from 'styled-components';
import CategoryExceptionsListing from '../../../components/global/CategoryExceptionsListing/CategoryExceptionsListing';
import { COLORS } from '@ydistri/theme';

export const ColoredHeadlineRow = styled(Row)`
  background-color: ${COLORS.PRIMARY_LIGHT};
  padding: 0.5rem;
  margin: 0.25rem;
`;

const CategoryExceptionsModal: React.FC = () => {
  const modalId = AvailableModals.CATEGORY_EXCEPTIONS;
  const dispatch = useAppDispatch();
  const open = useSelector((state: ReduxState) => state.modal.openedModal === modalId);
  const handleClose = useCallback(() => dispatch(closeModal()), [dispatch]);

  const [displayType, setDisplayType] = React.useState<ExceptionsModalDisplayType>(
    ExceptionsModalDisplayType.CATEGORY,
  );

  const handleDisplayTypeChange = useCallback((value: SegmentedValue) => {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- called by AntD component, we want to treat the value as ExceptionsModalDisplayType
    setDisplayType(value as ExceptionsModalDisplayType);
  }, []);

  const title = useMemo(() => {
    return (
      <Row $justifyContent="space-between" $gap="1rem">
        <Title>Exceptions overview</Title>
        <Segmented
          options={displayTypeOptions}
          value={displayType}
          onChange={handleDisplayTypeChange}
          style={{ marginRight: '50px' }}
        />
      </Row>
    );
  }, [displayType, handleDisplayTypeChange]);

  return (
    <StyledModal title={title} open={open} width="60%" onCancel={handleClose} footer={null}>
      <CategoryExceptionsListing displayType={displayType} />
    </StyledModal>
  );
};

export default CategoryExceptionsModal;
